const PROGRESS_BAR_STAGES = [
    'timeline.year',
    'timeline.style',
    'timeline.performance',
    'timeline.packages',
    'timeline.options',
    'timeline.confirmation',
];

export default PROGRESS_BAR_STAGES;
